import script from "./selectbox.vue?vue&type=script&setup=true&lang=js"
export * from "./selectbox.vue?vue&type=script&setup=true&lang=js"

import "./selectbox.vue?vue&type=style&index=0&id=994a98ea&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-994a98ea"]])

export default __exports__